<template>
  <div class="chrono-container">
    <div class="unit-container">
      <div class="unit-label">
        {{ $t('surveyQuestionScreen.chronoQuestion.hourLabel') }}
      </div>
      <div tabindex="0" :id="generatedId + 'hour-value'" v-enter-to-tab class="unit-value EnterToTab custom-focus"
           :class="{'disabled': viewMode}" @scroll.prevent="onScroll('hour')"
           @touchend="alignScrollValue('hour')" @mouseleave="alignScrollValue('hour')"
      >
        <div v-for="h in 24" :key="h">
          {{ h-1 }}
        </div>
      </div>
    </div>
    <div class="separator">:</div>
    <div class="unit-container">
      <div class="unit-label">
        {{ $t('surveyQuestionScreen.chronoQuestion.minuteLabel') }}
      </div>
      <div tabindex="0" :id="generatedId + 'minute-value'" v-enter-to-tab class="unit-value EnterToTab"
           :class="{'disabled': viewMode}" @scroll.prevent="onScroll('minute')"
           @touchend="alignScrollValue('minute')" @mouseleave="alignScrollValue('minute')"
      >
        <div v-for="m in 60" :key="m">
          {{ m-1 }}
        </div>
      </div>
    </div>
    <div class="separator">:</div>
    <div class="unit-container">
      <div class="unit-label">
        {{ $t('surveyQuestionScreen.chronoQuestion.secondLabel') }}
      </div>
      <div tabindex="0" :id="generatedId + 'second-value'" v-enter-to-tab class="unit-value EnterToTab"
           :class="{'disabled': viewMode}" @scroll.prevent="onScroll('second')"
           @touchend="alignScrollValue('second')" @mouseleave="alignScrollValue('second')"
      >
        <div v-for="s in 60" :key="s">{{ s-1 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import randomStringGenerator from '@/utils/randomStringGenerator';

export default {
  name: 'ChronoQuestion',
  props: {
    viewMode: {
      type: Boolean,
      default: false
    },
    answerName: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
      default: false,
    }
  },
  data: ()  => {
    return {
      hourValue: 0,
      minuteValue: 0,
      secondValue: 0,
      normalizedValue: '',
      scrollTimer: null,
      generatedId: '',
      isInitialization: true,
    }
  },
  watch: {
    answerName(newValue) {
      this.normalizedValue = newValue || '00:00:00';
    }
  },
  methods: {
    onScroll(field) {
      // Gets the actual value based on the scroll distance from the top of the container.
      let scroller;
      switch(field) {
        case 'hour':
          scroller = document.getElementById(this.generatedId + 'hour-value');
          this.hourValue = Math.round(scroller.scrollTop / 24);
          break;
        case 'minute':
          scroller = document.getElementById(this.generatedId + 'minute-value');
          this.minuteValue = Math.round(scroller.scrollTop / 24);
          break;
        case 'second':
          scroller = document.getElementById(this.generatedId + 'second-value');
          this.secondValue = Math.round(scroller.scrollTop / 24);
          break;
      }


      // Implement a scroll-stop detector to align the selected value and return the value to the parent
      if (this.scrollTimer !== null) {
        clearTimeout(this.scrollTimer);
      }

      this.scrollTimer = setTimeout(() => {
        this.alignScrollValue(field);

        this.normalizedValue = `${this.hourValue.toString().padStart(2, '0')}:${this.minuteValue.toString().padStart(2, '0')}:${this.secondValue.toString().padStart(2, '0')}`;

        // Emit event with the actual value
        if (!this.isInitialization) {
          this.$emit('onAnswered', this.normalizedValue);
        }
      }, 500);

      // Change color for the selected value
      for (let child of scroller.childNodes) {
        child.style = 'color: grey; font-weight: normal;';
      }

      switch(field) {
        case 'hour':
          scroller.querySelector(`:nth-child(${this.hourValue + 1})`).style = 'color: #4f23c9; font-weight: bold;';
          break;
        case 'minute':
          scroller.querySelector(`:nth-child(${this.minuteValue + 1})`).style = 'color: #4f23c9; font-weight: bold;';
          break;
        case 'second':
          scroller.querySelector(`:nth-child(${this.secondValue + 1})`).style = 'color: #4f23c9; font-weight: bold;';
          break;
      }
    },
    alignScrollValue(field) {
      // Align the scrollable value to the label
      let scroller;
      switch(field) {
        case 'hour':
          scroller = document.getElementById(this.generatedId + 'hour-value');
          scroller.scrollTop = this.hourValue * 24;
          break;
        case 'minute':
          scroller = document.getElementById(this.generatedId + 'minute-value');
          scroller.scrollTop = this.minuteValue * 24;
          break;
        case 'second':
          scroller = document.getElementById(this.generatedId + 'second-value');
          scroller.scrollTop = this.secondValue * 24;
          break;
      }

    },
    adjustToNormalizedValue(value) {
      if (value !== null) {
        const values = value.split(':');
        if (values.length !== 3) {
          console.error('invalid value');
          return;
        }
        const hourScroller = document.getElementById(this.generatedId + 'hour-value');
        const minuteScroller = document.getElementById(this.generatedId + 'minute-value');
        const secondScroller = document.getElementById(this.generatedId + 'second-value');

        hourScroller.scrollTop = values[0] * 24;
        minuteScroller.scrollTop = values[1] * 24;
        secondScroller.scrollTop = values[2] * 24;

      }
    }
  },
  created() {
    this.generatedId = randomStringGenerator(20);
  },
  mounted() {
    this.adjustToNormalizedValue(this.answerName);
    
    // We need to prevent calling onAnswered event when initializing the value from parameter
    setTimeout(() => {
      this.isInitialization = false;
    }, 600);

    let scroller = document.getElementById(this.generatedId + 'hour-value');
    scroller.querySelector(':nth-child(1)').style = 'color: #4f23c9; font-weight: bold';

    scroller = document.getElementById(this.generatedId + 'minute-value');
    scroller.querySelector(':nth-child(1)').style = 'color: #4f23c9; font-weight: bold';

    scroller = document.getElementById(this.generatedId + 'second-value');
    scroller.querySelector(':nth-child(1)').style = 'color: #4f23c9; font-weight: bold';

  }
}
</script>

<style scoped>
.chrono-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.separator {
  margin-top: 20px;
  font-size: 30px;
  font-weight: bold;
  margin-right: 10px;
}

.unit-label {
  font-weight: bold;
}

.unit-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
}

.unit-value {
  display: flex;
  flex-direction: column;
  height: 96px;
  width: 50px;
  text-align: center;
  padding: 0 5px;
  overflow-y: auto;
  scrollbar-width: none;
  box-shadow: inset 0px 10px 10px -10px #5f5f5f, inset 0px -10px 10px -10px #5f5f5f;
  background-color: white;
  border-radius: 0.4rem;
  color: #5f5f5f;
  border: 1px solid #5f5f5f;
}

.unit-value div{
  height: 24px;
  margin: 0;
  padding: 0;
}

.unit-value div:first-child {
  margin-top: 36px;
}
.unit-value div:last-child {
  margin-bottom: 36px;
}

.unit-value.disabled {
  overflow-y: hidden;
  border-color: #ababb5;
  background-color: #e9ecef;
}

.unit-value.disabled div {
  color: #495057 !important;
}
</style>